export default __webpack_public_path__ + "static/media/3024.80fe6bcf.png";